import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const Editorial = () => {
  return (
    <Container>
    <h2 className="display-6 fw-bold my-4">Editorial Decision and Revision

    </h2>
    <hr />

    <p className="joab-common-para my-4">All the articles, reviews and communications published in Green Publication journals go through the peer-review process and receive at least two review reports. The in-house editor will discuss each step of the process with the external academic editor and communicate decisions to the authors regarding the following:</p>

  
    <ul className="joab-common-para my-4">
        <li> <span className="fw-bold">Accept in Present Form:</span>  The paper is accepted without any further changes.</li>

        <li> <span className="fw-bold">Accept after Minor Revisions:</span>  The paper is in principle accepted after revision based on the reviewer’s comments. Authors are given five days for minor revisions.</li>

        <li> <span className="fw-bold">Reconsider after Major Revisions:</span> The acceptance of the manuscript would depend on the revisions. The author needs to provide a point by point response or provide a rebuttal if some of the reviewer’s comments cannot be revised. Usually, only one round of major revisions is allowed. Authors will be asked to resubmit the revised paper within ten days and the revised version will be returned to the reviewer for further comments.</li>

        <li > <span className="fw-bold">Reject and Encourage Resubmission:</span>  Reject and Encourage Resubmission: An article where additional experiments are needed to support the conclusions will be rejected and the authors will be encouraged to re-submit the paper once further experiments have been conducted.</li>

        <li> <span className="fw-bold">Reject:</span>  The article has serious flaws, makes no original contribution, and the paper is rejected with no offer of resubmission to the journal.</li>
       
    </ul>

   


  </Container>
  );
};

export default Editorial;
